import dayjs from "dayjs";

export function formatTimestamp(seconds: number): string {
  return dayjs(new Date(seconds * 1000)).format("YYYY/MM/DD HH:mm:ss");
}
